import { TextField as MuiTextField, styled } from "@mui/material"

export const TextField = styled(MuiTextField)(({ theme }) => ({
    "& > .MuiOutlinedInput-root": {
        borderRadius: theme.spacing(3),
    },
}))